import type {
  GetProjectDetailsResponse,
  UpdateProjectDetails,
} from "@nlc/shared-types";

import {
  useMutation,
  type UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";

import { projectDetailsKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useUpdateProjectDetails(
  projectId: number,
): UseMutationResult<
  GetProjectDetailsResponse,
  Error,
  UpdateProjectDetails,
  unknown
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateProjectDetails) =>
      await apiClient
        .url(`/projects/${projectId}/details`)
        .patch(data)
        .json<GetProjectDetailsResponse>(),
    onSuccess: (updatedData) => {
      queryClient.setQueryData(
        projectDetailsKeys.detail(projectId),
        updatedData,
      );
    },
  });
}
